import { z } from "zod";
import sceneObjectDataSchema from "./sceneObjectDataSchema";
import { vector3dSchema } from "../../primitivesSchema";

const lengthDimensionDataSchema = sceneObjectDataSchema.extend({
    start: vector3dSchema,
    end: vector3dSchema,
    offset: vector3dSchema,
    text: z.string(),
    fontSize: z.number().optional()
  });

export default lengthDimensionDataSchema;